module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9547.1993eeed.jpg";